import { PartialTheme } from "../types";
import { amcPalette, amcSemanticColors } from "./AmcTheme";

// Related Figma: https://www.figma.com/file/DqgCkKLMCh0BxCcc9KnC7O/%5BTwo-UI%5D-AMC-Component-Library?node-id=2%3A37&t=kN13qmKLW1EoDDAv-0
export const xboxPalette = {
    themePrimary: "#107c10",
    themeDark: "#054B16",
    themeDarker: "#054B16",
    themeDarkAlt: "#054B16",
    neutralTertiary: amcPalette.neutralTertiary,
    transparent: "transparent"
};

export const xboxTheme: PartialTheme = {
    palette: xboxPalette,
    semanticColors: amcSemanticColors,
};
